import { render, staticRenderFns } from "./jiyangEdit.vue?vue&type=template&id=a5d669b2&scoped=true&"
import script from "./jiyangEdit.vue?vue&type=script&lang=js&"
export * from "./jiyangEdit.vue?vue&type=script&lang=js&"
import style0 from "./jiyangEdit.vue?vue&type=style&index=0&id=a5d669b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d669b2",
  null
  
)

export default component.exports